import React from 'react';
import { Link } from 'react-router-dom';
import { FaBriefcase, FaChartLine, FaClock, FaShieldAlt, FaCheckCircle } from 'react-icons/fa';
import './LandingPage.css';

const LandingPage = () => {
    return (
        <div className="landing-page">
            <section className="landing-hero">
                <div className="container">
                    <div className="hero-content">
                        <h1>Grow Your Business with SkillHive</h1>
                        <p className="hero-subtitle">
                            Join thousands of professionals connecting with customers who need your services
                        </p>
                        <div className="hero-actions">
                            <Link to="/signup" className="btn btn-primary btn-lg">
                                <FaBriefcase /> Sign Up
                            </Link>
                            <Link to="/login" className="btn btn-secondary btn-lg">
                                Partner Login
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="benefits-section">
                <div className="container">
                    <h2>Why Partner with SkillHive?</h2>
                    <div className="benefits-grid">
                        <div className="benefit-card">
                            <div className="benefit-icon">
                                <FaChartLine />
                            </div>
                            <h3>Grow Your Income</h3>
                            <p>Access a steady stream of customers and increase your earnings</p>
                        </div>
                        <div className="benefit-card">
                            <div className="benefit-icon">
                                <FaClock />
                            </div>
                            <h3>Flexible Schedule</h3>
                            <p>Work on your own terms and choose jobs that fit your schedule</p>
                        </div>
                        <div className="benefit-card">
                            <div className="benefit-icon">
                                <FaShieldAlt />
                            </div>
                            <h3>Verified Customers</h3>
                            <p>All customers are verified for your safety and security</p>
                        </div>
                        <div className="benefit-card">
                            <div className="benefit-icon">
                                <FaCheckCircle />
                            </div>
                            <h3>Easy to Use</h3>
                            <p>Simple dashboard to manage jobs, earnings, and your profile</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="how-it-works">
                <div className="container">
                    <h2>How It Works</h2>
                    <div className="steps">
                        <div className="step">
                            <div className="step-number">1</div>
                            <h3>Apply Online</h3>
                            <p>Fill out our simple application form with your details and experience</p>
                        </div>
                        <div className="step">
                            <div className="step-number">2</div>
                            <h3>Get Verified</h3>
                            <p>Our team reviews your application and verifies your credentials</p>
                        </div>
                        <div className="step">
                            <div className="step-number">3</div>
                            <h3>Start Working</h3>
                            <p>Once approved, start receiving job requests and grow your business</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="cta-section">
                <div className="container">
                    <h2>Ready to Get Started?</h2>
                    <p>Join our network of trusted professionals today</p>
                    <Link to="/signup" className="btn btn-primary btn-lg">
                        Sign Up to Get Started
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default LandingPage;
